import { Component, ChangeDetectionStrategy, computed, input } from '@angular/core';

/**
 * Courbe d'appoint (sparkline) sous un chiffre clé : la tendance, sans axe ni valeur.
 * Le chiffre exact est celui de la carte ; la courbe ne dit que « monte » ou « descend ».
 */
@Component({
  selector: 'app-courbe',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="0 0 100 32" preserveAspectRatio="none" class="w-full h-8 overflow-visible" aria-hidden="true">
      <polygon [attr.points]="aire()" [attr.fill]="couleur()" fill-opacity="0.12"></polygon>
      <polyline [attr.points]="trace()" fill="none" [attr.stroke]="couleur()" stroke-width="2"
                stroke-linejoin="round" stroke-linecap="round" vector-effect="non-scaling-stroke"></polyline>
    </svg>
  `,
})
export class CourbeComponent {
  valeurs = input.required<number[]>();
  couleur = input('#009688');

  private points = computed(() => {
    const v = this.valeurs();
    if (!v.length) return [] as [number, number][];
    const min = Math.min(...v);
    const max = Math.max(...v);
    const etendue = max - min;
    const pasX = v.length > 1 ? 100 / (v.length - 1) : 0;
    // Série plate : une ligne au milieu, pas collée au bas comme un zéro.
    return v.map((y, i) => [i * pasX, etendue > 0 ? 30 - ((y - min) / etendue) * 28 : 16] as [number, number]);
  });

  trace = computed(() => this.points().map(([x, y]) => `${x},${y}`).join(' '));

  aire = computed(() => {
    const p = this.points();
    if (!p.length) return '';
    return `0,32 ${this.trace()} ${p[p.length - 1][0]},32`;
  });
}
